import { render, staticRenderFns } from "./ImagingInvestigations.vue?vue&type=template&id=7e7fe8f2&scoped=true&"
import script from "./ImagingInvestigations.vue?vue&type=script&lang=js&"
export * from "./ImagingInvestigations.vue?vue&type=script&lang=js&"
import style0 from "./ImagingInvestigations.vue?vue&type=style&index=0&id=7e7fe8f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7fe8f2",
  null
  
)

export default component.exports